import { VehiclePunctualityConfig } from '@modules/shared/models/vehicle/vehicle-punctuality-config';

export interface DeviationStyle {
    background: string;
    borderColor: string;
}

export const DEVIATION_COLORS: Record<string, DeviationStyle> = {
    early:    { background: '#FFD6DB',                   borderColor: '#FF3049' },
    onTime:   { background: '#57C457',                   borderColor: '#33A033' },
    late:     { background: '#FBEFCC',                   borderColor: '#EDAF00' },
    moreLate: { background: 'rgba(255, 145, 48, 0.40)',  borderColor: '#F28A3D' },
    mostLate: { background: 'rgba(240, 71, 255, 0.50)',  borderColor: '#F047FF' },
};

/**
 * Returns the deviation-tag background and border color for the given deviation
 * `seconds` value (positive = early, negative = late), using the same
 * thresholds as `VehiclePunctualityConfig`.
 */
export function deviationStyle(seconds: number, config: VehiclePunctualityConfig): DeviationStyle {
    if (seconds > config.early)      return DEVIATION_COLORS.early;
    if (seconds > config.onTime)     return DEVIATION_COLORS.onTime;
    if (seconds > config.lateLevel1) return DEVIATION_COLORS.late;
    if (seconds > config.lateLevel2) return DEVIATION_COLORS.moreLate;
    return DEVIATION_COLORS.mostLate;
}
